import React, { useState, useEffect } from "react";
import { Pie } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import axios from "axios";
import "./PieCharts.css";

ChartJS.register(ArcElement, Tooltip, Legend);

const PieCharts = ({ filters }) => {
  const [projectData, setProjectData] = useState({
    labels: ["No Data"],
    datasets: [{ data: [0], backgroundColor: ["#EAEAEA"] }],
  });

  const [applicationData, setApplicationData] = useState({
    labels: ["No Data"],
    datasets: [{ data: [0], backgroundColor: ["#EAEAEA"] }],
  });

  const [toggleType, setToggleType] = useState("BR");

  useEffect(() => {
    const hasFilters = Object.values(filters).some(
      (value) => value !== "" && value !== null
    );

    if (!hasFilters) {
      setProjectData({
        labels: ["No Data"],
        datasets: [{ data: [0], backgroundColor: ["#E8EAF6"] }],
      });
      setApplicationData({
        labels: ["No Data"],
        datasets: [{ data: [0], backgroundColor: ["#E8EAF6"] }],
      });
      return;
    }

    const fetchData = async () => {
      try {
        const response = await axios.get("https://api-usersreport-insights.haqdarshak.com/api/data", {
          params: { ...filters, toggleType },
        });

        const { projectWiseData, applicationWiseData } = response.data;

        // ✅ Show project-wise data for all toggle types
        const labels = Object.keys(projectWiseData || {});
        const values = Object.values(projectWiseData || {});
        const hasData = labels.length > 0 && values.some((val) => val > 0);

        setProjectData({
          labels: hasData ? labels : ["No Data"],
          datasets: [
            {
              data: hasData ? values : [0],
              backgroundColor: hasData
                ? ["#FAD3E0", "#B5EAD7", "#FFDAC1", "#A2D2FF"]
                : ["#E8EAF6"],
            },
          ],
        });

        const prefix = toggleType === "Open" ? "Open" : toggleType.toUpperCase();

        const combinedDI =
          (applicationWiseData?.[`${prefix}_DI`] || 0) +
          (applicationWiseData?.[`${prefix}_MSME`] || 0);
        const DFL = applicationWiseData?.[`${prefix}_DFL`] || 0;
        const YC = applicationWiseData?.[`${prefix}_YC`] || 0;

        const hasAppData = combinedDI + DFL + YC > 0;

        setApplicationData({
          labels: hasAppData ? ["DI", "DFL", "YC"] : ["No Data"],
          datasets: [
            {
              data: hasAppData ? [combinedDI, DFL, YC] : [0],
              backgroundColor: hasAppData
                ? ["#FFB4A2", "#6D6875", "#B5838D"]
                : ["#E8EAF6"],
            },
          ],
        });
      } catch (error) {
        console.error("Error fetching data:", error);
        setProjectData({
          labels: ["No Data"],
          datasets: [{ data: [0], backgroundColor: ["#E8EAF6"] }],
        });
        setApplicationData({
          labels: ["No Data"],
          datasets: [{ data: [0], backgroundColor: ["#E8EAF6"] }],
        });
      }
    };

    fetchData();
  }, [filters, toggleType]);

  const projectOptions = {
    cutout: "50%",
    plugins: {
      tooltip: {
        bodyFont: {
          size: 10,     // ✅ larger text
          
        },
        padding: 16,     // ✅ more padding
        boxPadding: 5,  // ✅ more space for color box
        callbacks: {
          label: (tooltipItem) => {
            const label = tooltipItem.label || "Unknown";
            const value = tooltipItem.raw;
            return `${label}: ${value}`;
          },
        },
      },
      legend: {
        display: false,
      },
    },
  };
  
  const applicationOptions = {
    plugins: {
      tooltip: {
        bodyFont: {
          size: 14,
          weight: 'bold',
        },
        padding: 12,
        boxPadding: 10,
        callbacks: {
          label: (tooltipItem) => {
            const label = tooltipItem.label || "Unknown";
            const value = tooltipItem.raw;
            return `${label}: ${value}`;
          },
        },
      },
      legend: {
        display: true,
        position: "top",
        labels: {
          boxWidth: 20,
          padding: 15,
          font: {
            size: 14,
          },
        },
      },
    },
  };
  

  return (
    <div className="pie-charts-container-v2">
      <div className="toggle-buttons3">
        {[ "Open", "DS","BR"].map((type) => (
          <button
            key={type}
            className={toggleType === type ? "active" : ""}
            onClick={() => setToggleType(type)}
          >
            {type}
          </button>
        ))}
      </div>

      <div className="pie-charts-row">
        <div className="pie-chart">
          <div className="pie-chart-wrapper">
            <Pie data={projectData} options={projectOptions} />
            <div className="pie-chart-title-box">Project Organization-Wise Data</div>
          </div>
        </div>

        <div className="pie-chart">
          <div className="pie-chart-wrapper">
            <Pie data={applicationData} options={applicationOptions} />
            <div className="pie-chart-title-box">Service Type</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PieCharts;
